import React from 'react';
import { X } from 'lucide-react';
import { ui } from './styles';

export default function FormModal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'lg',
}) {
  if (!isOpen) return null;

  const sizeClass = {
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
  }[size] || 'max-w-2xl';

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={ui.modalOverlay} onClick={handleOverlayClick}>
      <div
        className={`${ui.modal} ${sizeClass}`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={ui.modalHeader}>
          <h2 className="text-lg font-semibold text-text">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-muted transition hover:bg-slate-100 hover:text-text"
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
        </div>

        <div className={ui.modalBody}>{children}</div>

        {footer && <div className={ui.modalFooter}>{footer}</div>}
      </div>
    </div>
  );
}
